export const VACANCY_ANNOUNCE_MODAL_NAME = 'vacancyAnnounce';
